import React, { useState } from 'react';
import styled from 'styled-components';
import { Radio, Space } from 'antd';
import { ReactComponent as MpesaIcon } from '../../assets/images/Mpesa.svg';
import { ReactComponent as MastercardIcon } from '../../assets/images/Mastercard.svg';
import { ReactComponent as VisaIcon } from '../../assets/images/Visa.svg';
import { ReactComponent as CardIcon } from '../../assets/images/card.svg';
import { BLACK } from '../../utils/colors';

const SelectorContainer = styled.div``;

const SectionTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${BLACK};
  margin-bottom: 24px;

  @media (max-width: 768px) {
    font-size: 16px;
    margin-bottom: 12px;
  }
`;

const StyledRadioGroup = styled(Radio.Group)`
  width: 100%;

  .ant-radio {
    top: 0;
  }

  .ant-radio-inner {
    width: 24px;
    height: 24px;
    border-color: #D1D5DB;
    border-width: 1.5px;
  }
  
  .ant-radio-checked .ant-radio-inner {
    border-color: #FF9800; /* Matching the Figma orange */
    border-width: 7px;
    background-color: #FFFFFF;
  }

  .ant-radio-checked .ant-radio-inner::after {
    display: none;
  }

  .ant-radio-wrapper:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner {
    border-color: #FF9800;
  }
`;

const OptionContainer = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #F3F4F6;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const OptionLabel = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: ${BLACK};
`;

const IconGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

type Props = {
  selectedMethod: string;
  onMethodChange: (method: string) => void;
};

const PaymentMethodSelector = ({ selectedMethod, onMethodChange }: Props) => {
  return (
    <SelectorContainer>
      <SectionTitle>Select payment method</SectionTitle>

      <StyledRadioGroup value={selectedMethod} onChange={(e) => onMethodChange(e.target.value)}>
        <OptionContainer active={selectedMethod === 'mpesa'} onClick={() => onMethodChange('mpesa')}>
          <LeftSide>
            <MpesaIcon width={24} height={24} />
            <OptionLabel>Pay with Mpesa</OptionLabel>
          </LeftSide>
          <Radio value="mpesa" />
        </OptionContainer>

        <OptionContainer active={selectedMethod === 'card'} onClick={() => onMethodChange('card')}>
          <LeftSide>
            <CardIcon width={20} height={20} />
            <OptionLabel>Card</OptionLabel>
            <IconGroup>
              <MastercardIcon width={24} />
              <VisaIcon width={32} />
            </IconGroup>
          </LeftSide>
          <Radio value="card" />
        </OptionContainer>
      </StyledRadioGroup>
    </SelectorContainer>
  );
};

export default PaymentMethodSelector;
